import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { CitiShopPropsService } from '../../utility/citi-shop-props.service';

@Component({
  selector: 'app-citi-shop-download',
  templateUrl: './citi-shop-download.component.html',
  styleUrls: ['./citi-shop-download.component.scss'],
  standalone: false
})
export class CitiShopDownloadComponent implements OnInit {
  downloadSection:any;
  @Input() contentDownload: any = '{}';
  @Input() disableDownloadCTAButton: boolean;
  @Output() ctabuttonClicked = new EventEmitter<boolean>();
  isMobile: boolean = false;
  bannerContent: any = {};

  constructor(public csp: CitiShopPropsService){}

  ngOnInit(): void {
    this.downloadSection = this.contentDownload?.preEnroll;
    this.onWindowResize(null);
    this.setBannerContent();
  }

  buttonClicked(event) {
    this.ctabuttonClicked.emit(event);
  }

  @HostListener('window:resize', ['$event'])
  private onWindowResize(e) {
    this.isMobile = window?.innerWidth < 768;
  }

  private setBannerContent(): void{    
    const deviceCont = this.csp.isPlatformDesktop() ? 'desktop' : 'tablet';
    this.bannerContent = this.contentDownload?.postEnroll?.[deviceCont];
  }

}
